
<portal to="modal" v-if="show">
    <Modal :show="show" fullscreen :closeOnBackdropClick="false" @onModalClose="handleClose">
        <div class="Upgrade">
            <h1 class="Upgrade-Title">Wählen Sie Ihr Paket</h1>
            <h3 class="Upgrade-Subtitle">Finden Sie die perfekte Lösung für Ihre Flotte</h3>

            <Pricing :planType="planType" :isMarketing="false" @onUpgrade="handleUpgrade" />

            <div class="Upgrade-Info">
                <p class="InfoText">
                    <i class="ri-information-line"></i>
                    Alle Preise verstehen sich zzgl. MwSt. Kündigung ist monatlich möglich.
                </p>
            </div>
        </div>
    </Modal>
</portal>
